import { APYCalculationMethod, ManualAPYOverride } from 'types/Portfolio/APYCalculation'
import { Text } from 'components/atoms/Text'
import styled from 'styled-components'
import { AUTOMATIC_APY_CALCULATION } from 'constants/apyCalculation'
import { descriptions } from 'constants/descriptions'

interface Props {
  method?: APYCalculationMethod
  manualAPYOverride: ManualAPYOverride | undefined
  currentApyInBPS: number | undefined
}

export function InfoWithLabel({ method, manualAPYOverride, currentApyInBPS }: Props) {
  const description = getDescription(method, manualAPYOverride, currentApyInBPS)
  return (
    <Wrapper>
      {method && !!currentApyInBPS && <WhiteText variant="body3">{getLabel(method)}</WhiteText>}
      {description && <WhiteText variant="body2">{description}</WhiteText>}
    </Wrapper>
  )
}

function getLabel(method: APYCalculationMethod): string {
  const labels: Record<APYCalculationMethod, string> = {
    manual: 'Data provided by the Asset Manager',
    automatic: 'Automatic Calculation',
  }

  return labels[method]
}

function getDescription(
  method: APYCalculationMethod | undefined,
  manualAPYOverride: ManualAPYOverride | undefined,
  currentApyInBPS: number | undefined,
) {
  if (method === 'manual' && !!manualAPYOverride) {
    return manualAPYOverride.description
  }

  if (currentApyInBPS) {
    return AUTOMATIC_APY_CALCULATION.longDescription
  }

  return descriptions.expectedApy
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const WhiteText = styled(Text)`
  color: ${({ theme }) => theme.colors.White};
`
